"use client";

import { CircleAlert as AlertCircle, ArrowRight, Gem, Shield, Smile, Sparkles, Stethoscope } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  icon: Stethoscope,
  title: "Roof Cleaning",
  description: "Professional removal of moss, algae, and debris to extend the lifespan of your roof and restore its original appearance.",
  href: "/OurExpertisePage",
  popular: false
}, {
  icon: Sparkles,
  title: "\n",
  description: "",
  href: "/OurExpertisePage",
  popular: false
}, {
  icon: Shield,
  title: "Roof Maintenance",
  description: "Proactive inspections and minor repairs to prevent leaks and structural damage before they become costly issues.",
  href: "/OurExpertisePage",
  popular: false
}, {
  icon: Smile,
  title: "Gutter Cleaning",
  description: "Thorough clearing of gutters and downspouts to ensure proper water drainage and protect your property foundation.",
  href: "/OurExpertisePage",
  popular: true
}, {
  icon: Gem,
  title: "Gutter Repair",
  description: "Expert sealing and realignment of gutter systems to stop leaks and ensure long-term performance and durability.",
  href: "/OurExpertisePage",
  popular: false
}, {
  icon: AlertCircle,
  title: "Commercial Services",
  description: "Specialized exterior cleaning solutions for businesses, ensuring your property maintains a professional and clean image.",
  href: "/GetAQuotePage",
  popular: false
}];
export default function Services() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="482" id="our-cleaning-arsenal" className="bg-background text-foreground py-20 md:py-28 lg:py-[140px] px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`max-w-[720px] mx-auto text-center transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="inline-block text-xs tracking-[0.2em] uppercase font-medium mb-6" style={{
          color: "var(--primary)"
        }}>
            Our Expertise
          </span>
          <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-[3.25rem] leading-[1.1] text-foreground mb-6">
            Professional care,{" "}
            <em className="italic font-light" style={{
            color: "var(--primary)"
          }}>
              engineered
            </em>{" "}
            for your property.
          </h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-default">
            From deep roof restoration to precision gutter repairs, every service at ROOFPRO is delivered with industrial
            precision and meticulous attention to detail — because your property deserves the best protection.
          </p>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16 md:mt-20">
          {services.map((service, i) => {
          const Icon = service.icon;
          const isPopular = service.popular;
          return <div key={i} data-index={i} className={`group relative flex flex-col p-10 border border-border transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-lg ${isPopular ? "shadow-md" : "shadow-sm"} ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            backgroundColor: isPopular ? "var(--accent)" : "var(--card)",
            borderRadius: "var(--radius-xl)",
            transitionDelay: gridVisible ? `${i * 80}ms` : "0ms"
          }}>
                {isPopular}

                

                <h3 className={`font-default font-semibold text-foreground mb-3 ${isPopular ? "text-[26px]" : "text-2xl"} leading-tight`}>
                  {service.title}
                </h3>

                <p className="text-sm text-muted-foreground leading-relaxed font-default flex-1 mb-6">
                  {service.description}
                </p>

                <Link to={service.href} className="inline-flex items-center gap-2 text-sm font-medium group/link w-fit" style={{
              color: "var(--primary)"
            }}>
                  
                  
                </Link>
              </div>;
        })}
        </div>

        {}
        <div ref={footerRef} className={`mt-16 md:mt-20 flex justify-center transition-all duration-700 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild variant="link" className="text-base font-medium group/all p-0 h-auto hover:no-underline" style={{
          color: "var(--foreground)"
        }}>
            
          </Button>
        </div>
      </div>
    </section>;
}